const purchaseProcessForm = document.querySelector('.purchase-process-form');

const pickAddresses = () => {
  const addresses = purchaseProcessForm.querySelectorAll('.purchase-process-form__address');
  addresses.forEach((address) => {
    address.addEventListener('click', () => {
      addresses.forEach((others) => {
        others.classList.remove('is-active');
      });
      address.classList.add('is-active');
    });
  });
};

const removeShippingFromCart = () => {
  const shippingPriceEle = document.querySelector('.prices-item__delivery');
  if (shippingPriceEle) {
    const priceLeftEle = shippingPriceEle.querySelector('.purchase-process-sidebar__prices-left');
    const priceRightEle = shippingPriceEle.querySelector('.purchase-process-sidebar__prices-right');
    priceLeftEle.innerHTML = priceLeftEle.dataset.label;
    priceRightEle.innerHTML = priceRightEle.dataset.label;
  }
};

const pasteAddress = () => {
  const savedAddresses = purchaseProcessForm.querySelectorAll('.purchase-process-form__address');
  savedAddresses.forEach((savedAddress, key) => {
    const selectedAddress = savedAddress
      .closest('.purchase-process-form__addresses')
      .querySelector('.purchase-process-form__addresses__right');
    savedAddress.addEventListener('click', () => {
      selectedAddress.innerHTML = savedAddress.querySelector('.purchase-process-form__address-info').innerHTML;
      const mainAddress = selectedAddress.closest('.purchase-process-form__addresses-main');
      mainAddress.querySelector('input').value = key;
      mainAddress.dataset.code = savedAddress.dataset.code;
      removeShippingFromCart();
    });
  });
};

if (purchaseProcessForm) {
  // Addresses accordion
  const mainAddress = purchaseProcessForm.querySelector('.purchase-process-form__addresses-main');
  if (mainAddress) {
    const parent = mainAddress.closest('.purchase-process-form__addresses');
    const content = parent.querySelector('.purchase-process-form__addresses-other');
    mainAddress.addEventListener('click', () => {
      mainAddress.classList.toggle('is-active');
      slideToggle(content, 300, 'flex');
    });
  }

  pickAddresses();

  // Checkbox dropdowns
  const dropdowns = document.querySelectorAll('.purchase-process-form__checkbox-dropdown');
  dropdowns.forEach((dropdown) => {
    const checkbox = dropdown.querySelector('.checkbox');
    const input = checkbox.querySelector('input');
    const inputsDropdown = dropdown.querySelector('.purchase-process-form__checkbox-dropdown__inputs');

    input.addEventListener('change', (ev) => {
      if (ev.currentTarget.checked) {
        slideDown(inputsDropdown, 300, 'flex');
      } else {
        slideUp(inputsDropdown, 300, 'none');
        const inputs = inputsDropdown.querySelectorAll('.mod-input');
        inputs.forEach((item) => {
          item.classList.remove('is-validation-failed');
          // const error = item.querySelector('.fv-plugins-message-container');
          // error.innerHTML = '';
        });
      }
    });
  });

  // Change button if paypal option is clicked
  const paymentDropdowns = document.querySelectorAll(
    '.purchase-process-dropdown--payment .purchase-process-dropdown__header',
  );
  paymentDropdowns.forEach((paymentDropdown) => {
    paymentDropdown.addEventListener('click', (ev) => {
      ev.target
        .closest('form')
        .querySelector('.purchase-process-form__footer-btns')
        .classList.toggle('show-paypal', ev.target.id === 'paypal-payment');
    });
  });
  pasteAddress();

  // Open Edit Address Form
  const editAddressBtn = document.querySelectorAll(
    '.purchase-process-form__address-edit-button, .purchase-process-form__address.new-address .purchase-process-form__address-inner',
  );
  editAddressBtn.forEach((ele) => {
    ele.addEventListener('click', (ev) => {
      const parentEle = ev.target.closest('.purchase-process-form__address');
      const hiddenForm = parentEle.querySelector('.purchase-process-form__address-edit-hidden-form');
      if (hiddenForm) {
        slideToggle(hiddenForm, 300, 'block');
      }
    });
  });
}

// *******************************************************
// Open login modal
// *******************************************************

attachEvent('.open-login-modal', 'click', (openLoginModal) => {
  openLoginModal.target.closest('.purchase-process-form').querySelector('.login-modal').classList.add('is-open-modal');
  toggleBodyScrollLock(true);
});
